module.exports = __webpack_public_path__ + "static/media/IMG_1843.b609ccd6.jpeg";